import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar, ErrorMessage,
  LifeSaverForm,
  ScreenHeader, TextArea
} from '../../components';
import { useCreateOrUpdate, useFormData } from '../../hooks';

import { NewFAContext } from '.';

const formConfig = {
  fields: [
    { 
      id: 'financial-planning', 
      fieldName: 'financial_planning',
      type: 'text' as const,
      required: false 
    },
    { 
      id: 'financial-planning-details', 
      fieldName: 'financial_planning_details',
      type: 'text' as const,
      required: false 
    }
  ]
};


export function NewFAFinancialPlanning() {
  const navigate = useNavigate();
  const { funeralArrangement, update } = useContext(NewFAContext);
  const { handleCreateOrUpdate } = useCreateOrUpdate('funeral_arrangements');
  const { handleData, errors } = useFormData(formConfig);
    
  const handleBack = useCallback(() => {
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(async () => {
    const formData = handleData();

    const payload = {
      ...formData,
      user_id: funeralArrangement?.user_id || null,
      person_id: funeralArrangement?.person_id || null
    };

    try {
      await handleCreateOrUpdate(funeralArrangement?.id || '', payload);
      await update();
      navigate('../summary');
    } catch (err) {
      console.error('Error saving financial planning:', err);
    }
  }, [ navigate, funeralArrangement, handleCreateOrUpdate, update, handleData ]);

  return (
    <div className="new-fa-disposition screen">
      <ScreenHeader 
        title="Financial Planning"
        description="Provide instructions for financing your final arrangements."
        steps={6}
        step={6}
        handleBack={handleBack}
      />

      <LifeSaverForm 
        icon="money_bag"
        header="How to pay?"
      >
        <TextArea
          id="financial-planning"
          name="financial_planning"
          label="Financial Planning"
          placeholder="Enter details about how funeral costs should be covered..."
          style={{ maxWidth: '100%' }}
        />
        <TextArea
          id="financial-planning-details"
          name="financial_planning_details"
          label="Additional Financial Details"
          placeholder="Any additional financial instructions..."
          style={{ maxWidth: '100%' }}
        />
      </LifeSaverForm>

      <ErrorMessage message={errors[0]} />
      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}